import React from 'react';
import Zoom from 'react-medium-image-zoom';

const title = "Stock Summary Report";
const description = `The Stock Summary Report provides a concise, real-time snapshot of the physical quantities of inventory on hand, often displaying both the count and the related financial valuation (closing value) at a specific point in time. While functionally similar to an Inventory Summary, the Stock Summary is frequently utilized for daily operational and quantitative decision-making. Key details include the quantity on hand, the opening and closing stock values, and the inward and outward movement of goods (purchases and sales) over a specified period. This report is essential for warehouse managers and operational staff, as it allows for quick identification of stock availability across various locations or warehouses, helping to prevent stockouts and inform immediate purchasing or fulfillment decisions.`;

const images = [
    '/images/reports/purchase-by-supplier/purchase-by-supplier.png', // 0
];


const StockSummaryReport: React.FC = () => {

    return (
        <div className="max-w-4xl lg:max-w-5xl min-h-screen bg-gray-50 flex gap-2">
            <div className="overflow-auto mx-auto flex-2">

                <div className="mb-6">
                    <h1 className="text-3xl font-bold pt-4 text-gray-900">
                        {title}
                    </h1>
                    <p className="text-gray-600 mt-4">
                        {description}
                    </p>
                    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 my-6">
                        <Zoom>
                            <img
                                src={images[0]}
                                alt={title}
                                className="w-full max-w-4xl h-auto border border-gray-200 rounded-lg shadow-sm mx-auto"/>
                        </Zoom>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default StockSummaryReport;
